export const YOUR_INFO_CLASS_NAMES = {
  title: 'text-style-e text-neutral-900 mb-6 mt-6 first:mt-0',
  subtitle: 'text-style-g text-neutral-700 mb-6 -mt-2 first:mt-0',
  subheading: 'text-style-f-em text-neutral-700 mb-6 -mt-2 first:mt-0',
  description: 'text-style-g text-neutral-700 mb-6',
  heading: 'text-style-g-em text-neutral-700 mb-6',
};

export const YOUR_INFO_FIELDS = {
  CONFIRM_ACCOUNT: 'confirm_account',
  BANKRUPTCY_IVA: 'bankruptcy_iva',
};

export const YOUR_INFO_ADDRESS_FIELDS = {
  ADDRESS: 'address',
  YEARS_AT_ADDRESS: 'yearsAtAddress',
};

export const ADDRESS_DEFAULT_VALUE = {};

export const OMNI_PLACEHOLDER = {
  rateCardProducts: {
    name: 'placeholder',
    value: 'placeholder',
  },
  titles: {
    name: 'placeholder',
    value: 'placeholder',
  },
  genders: {
    name: 'placeholder',
    value: 'placeholder',
  },
  maritalStatuses: {
    name: 'placeholder',
    value: 'placeholder',
  },
  residentialStatuses: {
    name: 'placeholder',
    value: 'placeholder',
  },
  yearsAtAddress: {
    name: 'placeholder',
    value: 'placeholder',
  },
  employmentStatuses: {
    name: 'placeholder',
    value: 'placeholder',
  },
  yearsSelfEmployed: {
    name: 'placeholder',
    value: 'placeholder',
  },
  yearsWithEmployer: {
    name: 'placeholder',
    value: 'placeholder',
  },
  sourcesOfIncome: {
    name: 'placeholder',
    value: 'placeholder',
  },
};

export const MINIMUM_TOTAL_MONTHS_AT_ADDRESS = 36;

export const MAXIMUM_OMNI_ERROR_CODE_TO_DISPLAY = 20301;

export const ALWAYS_SHOW_OMNI_ERROR_CODES = [20601];

export const ERROR_1190 =
  'Your previously selected rate is no longer available. Please reach out to Kanda for assistance with this error';

export const OMNI_TEST_EMAIL = {
  ACCEPT: 'accepttest@ocrf.co.uk',
  DECLINE: 'declinetest@ocrf.co.uk',
  REFER: 'refertest@ocrf.co.uk',
};

export const ALLIUM_TEST_MIDDLE_NAME = {
  ACCEPT: 'TestAccept',
  DECLINE: 'TestDecline',
  REFER: 'TestRefer',
};

export const HUMM_TEST_STREET = {
  ACCEPT: 'warning-ob-accept',
};

export const HUMM_TEST_SUB_500_STREET = {
  ACCEPT: 'Accept',
};

export const ETIKA_TEST_MONTHLY_INCOME = {
  ACCEPT: 200000,
  DECLINE: 10000,
  REFER: 100000,
};

export const ETIKA_TEST_FIRST_NAME = {
  ACCEPT: 'mock',
  DECLINE: 'mock decline',
  REFER: 'mock warn',
  MIXED: 'mock mixed',
};
